const RecoverPasswordInitialValues = {
    email: ''
}

export default RecoverPasswordInitialValues
